import { Router } from "next/router";
import * as NProgress from "./utils/nprogress";

Router.events.on("routeChangeStart", () => {
	NProgress.start();
});

Router.events.on("routeChangeError", () => {
	NProgress.end();
});

Router.events.on("routeChangeComplete", () => {
	global.scrollTo(0, 0);
	NProgress.end();
});
